import { useEffect, useRef } from 'react';
import {
  bootstrapperAPI,
  downloadServiceAPI,
  uploadServiceAPI
} from 'src/libraries/axios';
import { useOktaAuth } from '@okta/okta-react';

const clientAPI = {
  download: downloadServiceAPI,
  upload: uploadServiceAPI
};

export default function useRestApiClient(type, settings) {
  const { oktaAuth, authState } = useOktaAuth();
  const tokenRef = useRef(null);
  const client = type ? clientAPI[type](settings) : bootstrapperAPI(settings);

  client.interceptors.request.use(
    (config) => {
      const token = tokenRef.current ? tokenRef.current : oktaAuth.getAccessToken();
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    tokenRef.current = oktaAuth.getAccessToken();
  }, [oktaAuth, authState]);

  return client;
}
